<div class="nav_container">
  <ul>
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Outils</li>
      <li>
        <a
          [routerLink]="['agenda/apprenant']"
          class="nav_item"
          routerLinkActive="active-link"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              fill="#E5E8EC"
              stroke="black"
              stroke-width="6"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
            />
          </svg>
          <span class="ml-3">Agenda</span>
        </a>
      </li>
    </div>
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Élèves</li>
      <li>
        <a
          [routerLink]="['stemd/add-eleve']"
          class="nav_item"
          routerLinkActive="active-link"
        >
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <style>
                .cls-1 {
                  fill: none;
                }
              </style>
            </defs>
            <g>
              <path
                fill="#E5E8EC"
                d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"
              />
              <path
                fill="#E5E8EC"
                d="M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z"
              />
              <path
                fill="#E5E8EC"
                d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"
              />
            </g>
            <g id="frame">
              <rect class="cls-1" height="32" width="32" />
            </g>
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Ajouter un élève</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['stemd/stemd-apprenants-stemd']"
          class="nav_item"
          routerLinkActive="active-link"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                id="Icon"
                d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
                stroke="#E5E8EC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
          <span class="flex-1 ms-3 whitespace-nowrap">Liste des élèves</span>
        </a>
      </li>
    </div>
  </ul>
  <ul>
    <!-- PLATEFORME LMS -->
    <!-- Scholar Vox -->
    <!-- <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Plateforme LMS
      </li>
      <ul>
        <li>
          <button class="nav_item text-left" (click)="openUrl(urlScholarVox)">
            <svg
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
              style="transform: scale(1.1)"
            >
              <path
                fill="#E5E8EC"
                d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
              />
            </svg>
            <span>Scholar Vox</span>
          </button>
        </li>
      </ul>
    </div> -->
  </ul>
</div>
